import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';

//Add
import { UAParser } from 'ua-parser-js';

class Comp extends React.Component {


	render() {
    let ua = UAParser();
    let helpId;

    if (ua.os.name === 'Android') {
      helpId = 472;
    }
    else if (ua.os.name === 'iOS') {
      helpId = 470;
    }
    else {
      helpId = 471;
    }
		return (
      <Button
        variant="outlined"
        color="primary"
        onClick={ () => this.props.helpOpen('id', helpId) }
      >
        画像のアップロード方法
      </Button>

		)
	}
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
